<div class="container-fluid-modal">

    <form class="form-inline required" #cat="ngForm" (ngSubmit)="cat.form.valid && submitForm(cat.value)" novalidate>

    <div class="add" *ngIf="!editData">
            <div class="ModalHeader">
                <h4 mat-dialog-title>Add Warehouse</h4>
                <div class="headerButton">
                    <button type="submit" class="btn btn-success"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save
                    </button>
                    <button type="button" class="btn btn-warning"  matDialogClose (click)="close()"><i class="fa fa-times" aria-hidden="true" ></i> Cancel
                    </button>
                </div>
            </div>

    <mat-dialog-content>
        <div class="card">
            <div class="card-body">
                    <div class="form-group col-lg-12">
                        <div class="form-group col-lg-12">
                            <label for="Location" class="labelRequired">Location </label>
                            <select id="mySelect" data-show-content="true" class="form-control" placeholder="Location"
                                [(ngModel)]="model.location_id" name="location_id" required #location_id="ngModel" [ngClass]= "{'has-danger': cat?.submitted  && location_id?.invalid }">
                                <option disabled>Select Location</option>
                                <option *ngFor="let data of locationsData" [value]="data?.id">
                                    {{data?.name}}
                                </option>
                            </select>
                            <div *ngIf="cat?.submitted  && location_id?.invalid">
                                    <div [hidden]="!location_id.errors.required" class="formError"> * Location Name is required </div>
                            </div>
                        </div>
                    
                        <div class="form-group col-lg-12">
                            <label for="Warehouse" class="labelRequired">Warehouse </label>
                            <input type="text" class="form-control" placeholder="Warehouse" name="name" #name="ngModel" [(ngModel)]="user.name" required [ngClass]= "{'has-danger': cat?.submitted  && name?.invalid }">
                            <div *ngIf="cat?.submitted  && name?.invalid ">
                                <div [hidden]="!name.errors.required" class="formError"> * Warehouse Name is required </div>
                            </div>
                        </div>
                </div>                
            </div>

        </div>

    </mat-dialog-content>
</div>

    <div class="edit" *ngIf= "editData">
                <div class="ModalHeader">
                    <h4 mat-dialog-title>Edit Warehouse</h4>
                    <div class="headerButton">
                        <button type="submit" class="btn btn-success"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save
                        </button>
                        <button type="button" class="btn btn-warning" matDialogClose (click)="close()"><i
                                class="fa fa-times" aria-hidden="true"></i> Cancel
                        </button>
                    </div>
                </div>
    
                <mat-dialog-content>
                    <div class="card">
                        <div class="card-body">
                        <div class="form-group col-lg-12">
                            <div class="form-group col-lg-12">
                                <label for="Location" class="labelRequired">Location </label>
                                <select id="mySelect" data-show-content="true" class="form-control" placeholder="Location"
                                [(ngModel)]="locationId" name="location_id">
                                    <option disabled>Select Location</option>
                                    <option *ngFor="let data of locationsData" [value]="data?.id">
                                    {{data?.name}}
                                </option>
                                </select>
                            </div>
    
                            <div class="form-group col-lg-12">
                                <label for="Warehouse" class="labelRequired">Warehouse </label>
                                <input type="text" class="form-control" placeholder="Warehouse" name="name" [(ngModel)]="editData.edit.name" required #name="ngModel" [ngClass]="{'has-danger':cat?.submitted && name?.invalid }">
                                <div *ngIf="cat?.submitted && name?.invalid">
                                    <div [hidden]="!name.errors.required" class="formError"> *Warehouse Name is required </div>
                                </div>
                            </div>
                        </div>
                           
                        </div>
    
                    </div>
    
                </mat-dialog-content>
            </div>

    </form>
</div>